import { service } from '../../service';
import { images } from '~/static/constants.js';

const state = {
  all: [],
  page: 1,
  nbParPage: 12,
  endReached: false,
  currentTheme: '',
  currentCategory: 'trends',
  currentVideo: {},
  keyword: '',
  searchedVideos: [],
  video: {},
  currentRubrique: '',
  playerUrl: {},
  playlistFound: true,
  videoMedia: {},
  relatedVideos: [],
  loading: false,
  videoLoading: false,
  currentLive: {},
  checkLive: false,
  liveMedia: {},
  like:false,
  disLike:false,
  nbLike:0,
  nbDisLike:0,
};

const getters = {
  getNbLike(state){
    return state.nbLike
  },
  getNbDisLike(state){
    return state.nbDisLike
  },
  getAllVideos(state) {
    return state.all;
  },
  getRelatedVideos(state) {
    return state.relatedVideos;
  },
  getKeyword(state) {
    return state.keyword;
  },
  getCurrentVideo(state) {
    return state.currentVideo;
  },
  getSearchedVideos(state) {
    return state.searchedVideos;
  },
  getCurrentRubrique(state) {
    return state.currentRubrique;
  },
  getPlayerUrl(state) {
    return state.playerUrl;
  },
  getPlaylistFound(state) {
    return state.playlistFound;
  },
  getVideoMedia(state) {
    return state.videoMedia;
  },
  getLoading(state) {
    return state.loading;
  },
  getEndReached(state) {
    return state.endReached;
  },
  getVideoLoading(state) {
    return state.videoLoading;
  },
  getCurrentTheme(state) {
    return state.currentTheme;
  },
  getCurrentCategory(state) {
    return state.currentCategory;
  },
  getLiveMedia(state) {
    return state.liveMedia;
  },
  getCurrentPage(state) {
    return state.page;
  },
  getVideoLike(state) {
    return state.like;
  },
  getVideoDisLike(state) {
    return state.disLike;
  },
};
/*To do id Canal*/
const actions = {
  // toutes les videos avec pagination
  async paginateVideos({ commit }) {
    if ((state.currentCategory !== 'home' || (state.currentCategory === 'home' && state.page == 1 )) && !state.endReached)
    {
      commit('SET_LOADING', true);
      const params = {
        page: state.page,
        nbParPage: state.nbParPage,
        order_type: 'Desc',
        ordre: 'date',
        idCanal: process.env.ID_CHANNEL,
        notIn: process.env.NOT_IN ? process.env.NOT_IN : false
      };
      let fn = 'paginateVideos';
      if (state.keyword) {
        params.searchWord = state.keyword;
      } else if (state.currentTheme) {
        params.idTheme = state.currentTheme;
      } else {
        switch (state.currentCategory) {
          case 'trends':
            params.idChannel = process.env.ID_CHANNEL;
            delete params.ordre;
            if (process.env.NOT_HOME_CONF != true) { fn = 'paginateHomeVideosByChannel'; }
            break;
          case 'popular':
            params.ordre = 'nb_views';
            break;
          default:
        }
      }

      var randomValue = parseInt(Math.random()*10*Math.random()*10);
      console.time("timeEnd randomValue"+randomValue)
        const { data } = await new Promise((resolve, reject)=>{
            service[fn](params).then(
                response=>{
                    if(response.status===200){
                        resolve(response)
                        if(response.data.data.videos.length > 0){
                            var ids = response.data.data.videos.map(item=>{
                                return item.id;
                            });
                             service.getListStatsVideos({
                                list_videos: "[" + ids.join() + "]",
                                client:process.env.CLIENT ? process.env.CLIENT.toLowerCase() : ""
                            }).then(res=> {
                                resolve(res)
                                    if (res.status === 200) {
                                        commit('APPEND_STATS_VIDEOS',  { stats: res.data.data});
                                    }
                                },
                                error=>{
                                    console.log('error-------',error)
                                });

                            commit('APPEND_VIDEOS', {videos: response.data.data.videos});
                        }
                    }
                },
                error=>{
                    commit('APPEND_VIDEOS', []);
                    commit('SET_END_REACHED', true);
                });
        });
        console.timeEnd("timeEnd randomValue"+randomValue)
        commit('SET_LOADING', false);
        commit('INCREMENT_PAGE');
        if ( data.data.videos.length === 0 ||  data.data.videos.length < state.nbParPage) {
          commit('SET_END_REACHED', true);
        }
    }
  },

  async getSearchedVideo({ commit }, keyword) {
    commit('SET_LOADING', true);
    const { data } = await service.getVideoByWord(keyword);
    commit('FETCH_VIDEOS', data.data.videos);
    commit('SET_LOADING', false);
  },
  // themes's videos
  async setCurrentTheme({ commit }, theme) {
    commit('SET_CURRENT_THEME', theme);
    commit('SET_CURRENT_CATEGORY', 'all');
    commit('SET_KEYWORD', '');
    commit('SET_END_REACHED', false);
    commit('RESET_PAGE');
    commit('SET_VIDEOS', []);
  },

  /*
   Keyword
   */
  async setKeyword({ commit }, keyword) {
    commit('SET_KEYWORD', keyword);
    commit('SET_CURRENT_CATEGORY', 'all');
    commit('SET_CURRENT_THEME', '');
    commit('SET_END_REACHED', false);
    commit('RESET_PAGE');
    commit('SET_VIDEOS', []);
  },

  /*
 Current Video
 */
  async setCurrentVideo({ commit }, video) {
    commit('SET_CURRENT_VIDEO', video);
    var param = {video : video.id}
    if(window.$cookies.isKey('tokenUserFo')){
      param.user=window.$cookies.get('tokenUserFo')
    }
    console.log("param getAverageVote",param);
    if(param && param.video){
      const { data } = await service.getAverageVote(param);
      commit('SET_NB_LIKE', data.data.vote_like);
      commit('SET_NB_DIS_LIKE', Math.abs(data.data.vote_dislike));
      commit('SET_VIDEO_LIKE', data.data.myVote> 0);
      commit('SET_VIDEO_DIS_LIKE', data.data.myVote < 0);
    }

  },

  async getVidesoByTheme({ commit }, themeId) {
    commit('SET_LOADING', true);
    const { data } = await service.getVideoByTheme(themeId);
    commit('FETCH_VIDEOS', data.data.videos);
    commit('SET_LOADING', false);
  },
  async getVideoInfoById({ commit }, id) {
    commit('SET_VIDEO_LOADING', true);
    const { data } = await service.getVideoInfoById(id);
    commit('SET_VIDEO', data.data);
    commit('SET_VIDEO_LOADING', false);
  },
  async getVideoMediaById({ commit }, id) {
    const { data } = await service.getVideoMediUrl(id);
    commit('SET_VIDEO_MEDIA', data.video);
  },
  // a la une
  async setCurrentCategory({ commit }, category) {
    commit('SET_CURRENT_CATEGORY', category);
    commit('SET_CURRENT_THEME', '');
    commit('SET_KEYWORD', '');
    commit('SET_END_REACHED', false);
    commit('RESET_PAGE');
    commit('SET_VIDEOS', []);
  },
  async getVideoById({ commit }, id) {
    const { data } = await service.getVideoById(id);
    commit('SET_VIDEO', data);
  },
  async getCryptedUrl({ commit }, id) {
    const { data } = await service.getCryptedUrl(id);
    console.log("getCryptedUrl",data)
    commit('SET_PLAYER_URL', data);
  },
  async getCryptedPlaylistUrl({ commit }, id) {
    try {
      const { data } = await service.getCryptedPlaylistUrl(id);
      commit('SET_PLAYLIST_FOUND', true);
      commit('SET_PLAYER_URL', data);
    } catch (err) {
      commit('SET_PLAYLIST_FOUND', false);
    }
  },
  async fetchRelated({ commit }, params) {
    const paramsTmp = Object.assign({ idChannel: 1, max_associated_videos: 30 }, params);
    const options = params === undefined ? { idChannel: 1, max_associated_videos: 30 } : paramsTmp;
    const { data } = await service.getRelatedVideos(options);
    commit('FETCH_RELATED_VIDEOS', data.data.videos);
  },
  async getMostVisitedVideos({ commit }) {
    commit('SET_LOADING', true);
    const { data } = await service.getMostVisitedVideos({ idChannel: 1 });
    commit('FETCH_VIDEOS', data.data.videos);
    commit('SET_LOADING', false);
  },
  setCurrentRubrique({ commit }, currentRubrique) {
    commit('SET_CURRENT_RUBRIQUE', currentRubrique);
  },
  async updateVotes({ commit }, params) {

    const { data } = await service.updateVote(params);

    commit('SET_NB_LIKE', data.data.vote_like);
    commit('SET_NB_DIS_LIKE', Math.abs(data.data.vote_dislike));
    commit('SET_VIDEO_LIKE', params.vote> 0);
    commit('SET_VIDEO_DIS_LIKE', params.vote < 0);
  }
};

const mutations = {
  APPEND_VIDEOS(state, {videos}) {
    if(videos && videos.length > 0){
        const mappedVideos = videos.map(item => {
            if (!item.logo) {
                item.logo = images.placeholder;
            }
            item.logoerror = images.placeholder;

            return item;
        });

        const filterdVideos = mappedVideos.filter(item => {
            return state.all.length === 0 || !state.all.some(i => i.id === item.id);
        });

        state.all = state.all.concat(filterdVideos);
    }
  },
    APPEND_STATS_VIDEOS(state, {stats}) {
        if(state.all && state.all.length > 0){
             state.all.map(item => {
                if (item.hasOwnProperty('nb_views') && stats && stats.length > 0) {
                    delete item.nb_views;
                    item.nbviews =stats.find(v=>v.id===item.id).number_visits;
                }
                return item;
            });

        }
    },

  SET_VIDEOS(state, videos) {
    state.all = videos;
  },
  SET_VIDEO(state, video) {
    state.video = video;
  },
  SET_END_REACHED(state, endReached) {
    state.endReached = endReached;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  INCREMENT_PAGE(state) {
    state.page += 1;
  },
  RESET_PAGE(state) {
    state.page = 1;
  },
  SET_KEYWORD(state, keyword) {
    state.keyword = keyword;
  },
  SET_CURRENT_CATEGORY(state, category) {
    state.currentCategory = category;
  },
  SET_CURRENT_THEME(state, theme) {
    state.currentTheme = theme;
  },
  SET_CURRENT_VIDEO(state, video) {
    state.currentVideo = video;
  },
  SET_VIDEO_LOADING(state, videoLoading) {
    state.videoLoading = videoLoading;
  },
  SET_SEARCHED_VIDEOS(state, video) {
    state.searchedVideos = video;
  },
  SET_CURRENT_RUBRIQUE(state, currentRubrique) {
    state.currentRubrique = currentRubrique;
  },
  SET_PLAYER_URL(state, playerUrl) {
    state.playerUrl = playerUrl;
  },
  SET_PLAYLIST_FOUND(state, playlistFound) {
    state.playlistFound = playlistFound;
  },
  SET_VIDEO_MEDIA(state, videoMedia) {
    state.videoMedia = videoMedia;
  },
  FETCH_RELATED_VIDEOS(state, relatedVideos) {
    state.relatedVideos = relatedVideos;
  },
  FETCH_CURRENT_LIVE(state, currentLive) {
    state.currentLive = currentLive;
  },
  SET_CHECK_LIVE(state, checkLive) {
    state.checkLive = checkLive;
  },
  SET_LIVE_MEDIA(state, liveMedia) {
    state.liveMedia = liveMedia;
  },
  SET_VIDEO_LIKE(state, LIKE) {
    state.like = LIKE;
  },
  SET_VIDEO_DIS_LIKE(state,DIS_LIKE) {
    state.disLike =  DIS_LIKE;
  },
  SET_NB_LIKE(state,nb) {
    state.nbLike =  nb;
  },
  SET_NB_DIS_LIKE(state,nb) {
    state.nbDisLike =  nb;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/videos.js